// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__aBv5l","title":"ClientCherryInfo_title__2aGw2","itemText":"ClientCherryInfo_itemText__1C7WD"};